module.exports = __webpack_public_path__ + "static/img/es.8c819b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/flag/es.png
// module id = KZka
// module chunks = 0